import * as React from 'react'
import { SVGProps } from 'react'
const SvgTruckRound = (props: SVGProps<SVGSVGElement>) => (
  <svg width={36} height={26} viewBox="0 0 36 26" fill="none" {...props}>
    <path
      d="M19.931 1.002A2.678 2.678 0 0 1 22.61 3.68v15.762a2.678 2.678 0 0 1-2.678 2.678h-2.858c-1.478 0-2.687-1.492-3.996-2.18a2.457 2.457 0 0 0-1.145-.28c-.413 0-.803.101-1.145.28-1.31.688-2.518 2.18-3.997 2.18H3.11a1.648 1.648 0 0 1-1.65-1.646V2.294c0-.713.58-1.292 1.294-1.292h17.177Z"
      stroke="var(--black, #1C1915)"
      strokeWidth={1.339}
      strokeMiterlimit={10}
    />
    <path
      d="M34.93 15.041h-.002v4.82a2.26 2.26 0 0 1-2.262 2.259h-.095c-.739 0-1.31-.642-1.694-1.274a2.463 2.463 0 0 0-2.108-1.186c-.895 0-1.677.475-2.109 1.186-.384.632-.954 1.274-1.694 1.274h-1.018c-.74 0-1.339-.6-1.339-1.339V4.596c0-.739.6-1.338 1.339-1.338h5.3c.956 0 1.82.566 2.202 1.441l2.54 5.833a11.291 11.291 0 0 1 .94 4.51Z"
      stroke="var(--black, #1C1915)"
      strokeWidth={1.339}
      strokeMiterlimit={10}
    />
    <path
      d="M28.768 24.58a2.462 2.462 0 0 0 2.464-2.46 2.462 2.462 0 0 0-2.463-2.46 2.462 2.462 0 0 0-2.464 2.46 2.462 2.462 0 0 0 2.463 2.46ZM11.932 24.58a2.462 2.462 0 0 0 2.464-2.46 2.462 2.462 0 0 0-2.464-2.46 2.462 2.462 0 0 0-2.464 2.46 2.462 2.462 0 0 0 2.464 2.46ZM32.16 6.333h-3.786c-.739 0-1.338.6-1.338 1.339V8.89c0 .74.599 1.339 1.338 1.339h5.614"
      stroke="var(--black, #1C1915)"
      strokeWidth={1.339}
      strokeMiterlimit={10}
    />
  </svg>
)
export default SvgTruckRound
